import React from 'react';

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Material-ui

class Comp extends React.Component {


	render() {

		return (
			<ul className='stepBar'>
        <li className={this.props.step >= 0 ? "visited" : null}>
					<span className='icon'>1</span><br/>
					<span className='text'>自身について</span>
				</li>
        <li className={this.props.step >= 1 ? "visited" : null}>
					<span className='icon'>2</span><br/>
					<span className='text'>希望条件</span>
				</li>
        <li className={this.props.step >= 2 ? "visited" : null}>
					<span className='icon'>3</span><br/>
					<span className='text'>コメント</span>
				</li>
			</ul>
		)
	}
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
